/* Bull Interiors Luxury — behaviour: mobile nav, sticky header shadow, reveals, passcode gate */
(function () {
  'use strict';

  /* mobile nav */
  var toggle = document.querySelector('[data-nav-toggle]');
  if (toggle) {
    var nav = document.getElementById(toggle.getAttribute('aria-controls'));
    /* On the Home page, open the familiar stacked mobile dropdown by default. */
    if (nav && document.body.classList.contains('template-index') && window.matchMedia('(max-width: 720px)').matches) {
      toggle.setAttribute('aria-expanded', 'true');
      nav.hidden = false;
    }
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      if (nav) nav.hidden = open;
    });
  }

  /* header shadow once scrolled */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 4);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* one orchestrated reveal per section */
  var groups = document.querySelectorAll('[data-reveal-group]');
  if ('IntersectionObserver' in window && groups.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('rv-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    groups.forEach(function (group) {
      var kids = group.children;
      for (var i = 0; i < kids.length; i++) kids[i].classList.add('rv');
      io.observe(group);
    });
  }

  /* passcode gate (client-side presentation gate) */
  document.querySelectorAll('[data-passcode]').forEach(function (root) {
    var code = root.getAttribute('data-code');
    var form = root.querySelector('[data-passcode-form]');
    var input = root.querySelector('[data-passcode-input]');
    var error = root.querySelector('[data-passcode-error]');
    var body = root.querySelector('[data-passcode-body]');
    var KEY = 'bull-projects-unlocked';
    var show = function () {
      var tpl = body.querySelector('[data-passcode-content]');
      if (tpl) body.appendChild(tpl.content.cloneNode(true));
      body.hidden = false;
      form.closest('.passcode-gate').hidden = true;
    };
    try { if (sessionStorage.getItem(KEY) === code) show(); } catch (e) { /* storage unavailable */ }
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if ((input.value || '').trim() === code) {
        try { sessionStorage.setItem(KEY, code); } catch (err) {}
        show();
      } else if (error) {
        error.hidden = false;
        input.focus();
      }
    });
  });
})();
